import { t } from 'i18next';
import { Image } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import AppLogo from '~assets/app_logo.svg';
import { Button, CustomIcon } from '~components/index';
import useLocalStorage from '~hooks/useLocalStorage';
import { ROUTES } from '~routes/routesDictionary';
import { sidebarItemsRender } from './helpers/SidebarHandler';
import { updateUserNavigation } from './SidebarRequests';
import './Sidebar.scss';

export type SidebarModalOpts = 'deployModal' | 'none';

interface Props {
  collapse: boolean;
}
const Sidebar = ({ collapse }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { userData } = useLocalStorage();

  return (
    <div
      className={`sidebar ${collapse ? 'sidebar_hidden' : 'sidebar_visible'}`}
    >
      <div className="sidebar_content">
        <NavLink to={ROUTES.PLATFORM} className="sidebar_logo_container">
          <Image src={AppLogo} alt="app_logo" className="sidebar_logo" />
        </NavLink>
        {sidebarItemsRender(userData.sidebar!, location)}
        <div className="sidebar_userOptions">
          <CustomIcon
            name="FaUser"
            color="var(--sidebar-icon-color)"
            size="LG"
          />
          <div className="sidebar_userLogged">
            <div className="d-flex gap-2 align-items-center">
              {userData?.first_name ?? ' - '}
              <div
                title={t('btns.update_user')}
                onClick={async () => await updateUserNavigation()}
              >
                <CustomIcon
                  name="IoReload"
                  color="var(--sidebar-text-color)"
                  size="XS"
                  className="cursor-pointer"
                />
              </div>
            </div>
            <Button
              variant="link"
              iconName="BiLogOut"
              text="btns.logout"
              onClick={() => {
                localStorage.clear();
                navigate(ROUTES.LOGIN);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
